import { render, staticRenderFns } from "./Block0.vue?vue&type=template&id=0518da77&scoped=true&"
import script from "./Block0.vue?vue&type=script&lang=js&"
export * from "./Block0.vue?vue&type=script&lang=js&"
import style0 from "./Block0.vue?vue&type=style&index=0&id=0518da77&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0518da77",
  null
  
)

export default component.exports